var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCliente(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.844,
    height: 17.106,
    viewBox: "0 0 16.844 17.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2903",
    "data-name": "Caminho 2903",
    d: "M9.422,12.331a3.666,3.666,0,1,0-3.61-3.666A3.623,3.623,0,0,0,9.422,12.331Zm0,2.444C6.619,14.775,1,16.2,1,19.052v3.055H17.845V19.052C17.845,16.2,12.226,14.775,9.422,14.775Z",
    transform: "translate(-1 -5)",
    fill: "#012d5c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCliente);
export default __webpack_public_path__ + "static/media/Cliente.91fd83a6.svg";
export { ForwardRef as ReactComponent };